import { render } from "./EventTeamManage.vue?vue&type=template&id=273c2555&scoped=true"
import script from "./EventTeamManage.vue?vue&type=script&lang=js"
export * from "./EventTeamManage.vue?vue&type=script&lang=js"

import "./EventTeamManage.vue?vue&type=style&index=0&id=273c2555&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273c2555"]])

export default __exports__